// extracted by mini-css-extract-plugin
export default {"full":"Live_full__HoFs1","header":"Live_header__gi6hM","content":"Live_content__bdiJm","textbox":"Live_textbox__ksalT","card":"Live_card__d2zoX"};